import { TagVariants } from '../../components/Tag/Tag';

export type ActualSurveyStatuses =
  | 'Pågående'
  | 'Analysering pågår'
  | 'Ikke mulig å analysere'
  | 'Fullført';

export class SurveyStatusCardUtils {
  public static convertSurveyStatusToTagVariant(
    status: ActualSurveyStatuses,
  ): TagVariants {
    if (status === 'Pågående') {
      return 'info';
    }
    if (status === 'Analysering pågår') {
      return 'warning';
    }
    if (status === 'Ikke mulig å analysere') {
      return 'danger';
    }
    if (status === 'Fullført') {
      return 'success';
    }

    return 'zero';
  }

  public static isInvalidForAnalyzing(
    isActive: boolean,
    responseRate: number,
  ): boolean {
    return !isActive && responseRate === 0;
  }

  public static getDeadlineDate(
    createdAt: Date,
    deadlineInDays: number | undefined,
  ) {
    if (deadlineInDays === undefined || deadlineInDays === null || !createdAt)
      return null;

    const deadline = new Date(createdAt);
    deadline.setDate(deadline.getDate() + deadlineInDays);
    return deadline;
  }

  public static buildAnalyzeSurveyRoute(
    teamId: number,
    surveyId: number,
  ): string {
    const routeToBuild = '/teams/{{teamId}}/analyze-survey/{{surveyId}}/1';
    return routeToBuild
      .replace('{{teamId}}', `${teamId}`)
      .replace('{{surveyId}}', `${surveyId}`);
  }

  private static isPastDeadline(deadlineDate: Date): boolean {
    return Boolean(deadlineDate && new Date() >= deadlineDate);
  }
  private static hasAllAnswered(
    numberOfRespondents: number,
    numberOfTeamMembers: number,
  ): boolean {
    return Boolean(numberOfRespondents >= numberOfTeamMembers);
  }

  private static isAnalyzedOrAnalyzing(
    status: ActualSurveyStatuses,
    isActive: boolean,
    analyzeStatus: 'COMPLETED' | 'NOT_ANALYZED',
  ): boolean {
    const isStatusAnalyzing = status === 'Analysering pågår';
    const isAnalyzed = status === 'Fullført';
    const isSurveyInactive = !isActive;
    const isStillAnalyzing = analyzeStatus !== 'COMPLETED';

    return (
      isSurveyInactive && (isStatusAnalyzing || isAnalyzed) && isStillAnalyzing
    );
  }

  public static deactivatePatchDeadline(
    deadlineDate: Date,
    numberOfRespondents: number,
    numberOfTeamMembers: number,
    isActive: boolean,
    status: ActualSurveyStatuses,
    analyzeStatus: 'COMPLETED' | 'NOT_ANALYZED',
  ): boolean {
    return (!isActive ||
      this.isPastDeadline(deadlineDate) ||
      this.hasAllAnswered(numberOfRespondents, numberOfTeamMembers) || this.isAnalyzedOrAnalyzing(status, isActive, analyzeStatus));
  }
}
